import { Component, inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { HisBaseGlobalsService } from '../../../core/service/base/his-base-globals.service';

@Component( {
    selector: 'his-job-setting',
    templateUrl: './his-job-setting.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class HisJobSettingComponent {
    @Input( { required: true } ) setting: any;
    private baseGlobalService = inject( HisBaseGlobalsService );

    protected get title() {
        if ( this.baseGlobalService.system.operationMode !== 'cust' ) {
            return '';
        }
        return this.setting.name;
    }
}
